import React from 'react';

const Note = ({ children }) => <div className="note">{children}</div>;

export default Note;
